import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { LegacyStack } from '@shopify/polaris';
import Address from './Address'
import ProxyForm from '../ProxyForm'
import EditPassword from '../../EditPassword'
import EditContact from '../../EditContact'
import { CustomerContext } from '../../contexts/Customer'
import { ShopContext } from '../../contexts/Shop'
import { HostContext } from '../../contexts/Host'
import { FormProvider, Util } from '@thinkwell/react.common'

export default function Details(props) {
  const [customer, setCustomer] = useContext(CustomerContext)
  const [password, setPassword] = useState();
  const loginSubmitRef = useRef();
  const setSavingRef = useRef();

  const shop_name = useContext(ShopContext)
  const host = useContext(HostContext)
  const address = customer.default_address;

  Util.hideLoader('.details')

  const onEditPassword = (result) => {
    flushSync(() => {
      setPassword(result.password)
    })
    setSavingRef.current(true)
    loginSubmitRef.current()
  }

  const data = {
    'customer[email]': customer.email,
    'customer[password]': password
  }

  const onEditContactSaved = (customer) => {
    setCustomer(customer)
    // reload page to update enrollment assigned_to/by names
    window.location.reload()
  }

  return (<div className="row">
    <div className="columns large-6">
      <h2>{`${customer.first_name} ${customer.last_name}`}</h2>
      <p className="email note">{ customer.email }</p>
    </div>
    <div className="columns large-6">
      <h2>Addresses</h2>
      <div className="address note">
        { address ? <Address item={address} /> : null }
        <p><a id="view_address" href="/account/addresses">View Addresses</a></p>
      </div>
    </div>
    <div className="columns large-6">
      <LegacyStack>
        <EditContact forAccount
          item={customer}
          shop_name={shop_name}
          onSave={onEditContactSaved}
        />
        <EditPassword forAccount
          id={customer.id}
          shop_name={shop_name}
          onSave={onEditPassword}
          setSavingRef={setSavingRef}
        />
        <div style={{display: 'none'}}>
          <FormProvider data={data}><ProxyForm
          action={`/account/login?return_url=${window.location.href}`}
          submitRef={loginSubmitRef}
          proxy={{url: `${host}/accounts/login?shop_name=${shop_name}`}}
          bottomLink={{href: "/account/register", text: "Register a New Account"}}>
            <input readOnly type="hidden" name="form_type" value="customer_login" />
            <input readOnly type="hidden" name="customer[password]" value={password || ''} />
          </ProxyForm></FormProvider>
        </div>
      </LegacyStack>
    </div>
  </div>)
}
